import { motion } from "framer-motion";
import { ServiceCard } from "@/components/ServiceCard";
import { servicesData } from "@/lib/servicesData";
import { ShieldCheck } from "lucide-react";

const Services = () => {
  return (
    <div className="relative min-h-screen pt-28 pb-24" data-testid="services-page">
      {/* Background */}
      <div className="absolute inset-0 bg-[#020408]" />
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)`,
          backgroundSize: "64px 64px",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 bg-blue-500/10 border border-blue-500/20 rounded-full px-4 py-1.5 mb-6">
            <ShieldCheck className="w-4 h-4 text-blue-400" />
            <span className="text-blue-300 text-xs font-medium tracking-wide uppercase">
              Certification Services
            </span>
          </div>
          <h1 className="font-outfit font-bold text-4xl sm:text-5xl text-white tracking-tight">
            Our Services
          </h1>
          <p className="mt-4 text-slate-400 max-w-2xl mx-auto text-base md:text-lg">
            Comprehensive legal and technical certification services. Every certificate is minted as an NFT and signed on blockchain for immutable verification.
          </p>
        </motion.div>

        {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {servicesData.map((service, i) => (
              <ServiceCard key={service.slug} service={service} index={i} />
            ))}
          </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 text-center"
        >
          <div className="bg-[#0F1116]/60 backdrop-blur-xl border border-white/[0.06] rounded-2xl p-10 md:p-14 max-w-2xl mx-auto">
            <h3 className="font-outfit font-semibold text-2xl text-white">
              Need a Custom Certification?
            </h3>
            <p className="mt-3 text-slate-400">
              Our team can design a certification process tailored to your specific regulatory requirements.
            </p>
            <a
              href="/contact"
              data-testid="services-custom-cta"
              className="inline-block mt-6 bg-blue-600 hover:bg-blue-500 text-white font-medium px-8 py-3 rounded-md transition-all duration-300 hover:shadow-[0_0_30px_rgba(59,130,246,0.4)] hover:-translate-y-0.5"
            >
              Contact Our Team
            </a>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Services;
